/*
 * ## ⭐⭐ 정본 `ChecklistTemplatesPage` 에서 ★ ⭐ «가져올 것이 0» 이다 (2026-10-10 실측)
 *
 * 같은 라우트를 ★ 이 파일이 ⭐ 이미 그린다. 정본과 맞대니(주석·글자열을 ⭐ 덮고 셌다):
 *
 *   api 호출 ★ 4 ⇔ 4 · useState ★ 9 ⇔ 9 · className ★ 35 ⇔ 35 · on[대문자] 손 ★ 13 ⇔ 13 · role= ★ 6 ⇔ 6
 *   i18n 열쇠 ★ 21 ⇔ 21 ⇒ ⇒ ⭐ «정본에만» ★ 0 · «우리에만» ★ 0 (앞가지 project.btn · project.tmpl)
 *   크기 ⇒ ⭐ «코드 줄»(주석·빈 줄을 뺀 수) ⇒ 정본 ★ 235 ⇔ 우리 ★ 238
 *          ⇒ 날 줄(wc -l)                  ⇒ 정본 ★ 272 ⇔ 우리 ★ 316 (⇐ 바탕 d4b2ff7f2)
 *          ⇒ numstat ⇒ ★ ＋49 −5 (⇐ 같은 바탕) ⇒ ⇒ ⚠ 지금 996851264 로 재면 ★ ＋72 −5 다
 *             ⇒ ⇒ ⭐ 늘어난 23 이 ★ 이 머리말이다 ⇒ ⇒ ★ 그래서 «바탕»을 못 박는다.
 *          ⇒ ⚠ ⭐ 코드 줄은 ★ 이 쪽지가 ⛔ 안 바꾼다(238 ⇒ 238 실측).
 *   서버 ⇒ modules/tasks/checklist-templates.routes.ts 가 ★ ⭐ «글자까지 같다»
 *          (8,964 자 · wc -l ★ 236 줄 · 코드 줄 ★ 197 · 라우트 ★ 4 ⇒ get · post · patch · delete)
 *          ⇒ ⇒ ⭐ 즉 ★ 서버 일 ⭐ 0 · 새 API ⭐ 0 · 마이그 ⭐ 0
 *
 *   ⚠ 2026-10-10 정정 — ★ 위 수를 ⭐ 고쳤다(종전: 273 ⇔ 317 줄 · numstat 을 바탕 없이).
 *     ⇒ ① split 셈이 ★ ＋1 · ② ⭐ 이 쪽지가 ★ «우리 쪽» 수를 스스로 키웠다
 *     ⇒ ⇒ 자세한 까닭은 ★ SpaceV2Page.tsx 머리말의 ⭐ 같은 정정에 있다.
 *
 * ⇒ ⭐⭐ 내용 차이는 ★ ⭐ «하나»다 — ⇒ 서식 아이콘의 ★ 폴백(⇒ 바로 아래 머리말이 적는다).
 *   ⇒ ⚠ 그 하나도 ★ 「안 가져왔다」가 아니라 ⇒ ⭐ 「가져오면 ★ 고친 것이 ⭐ 되돌아간다」다
 *      ⇒ ⇒ ★ checklist-v2.guard.test.tsx ③ 이 ⭐ 그것을 잠근다.
 *
 * ⏳ **만료 조건 — ★ «내놓는 이름»으로**
 *   ⇒ ⭐ 정본 `ChecklistTemplatesPage` 가 ★ ⭐ «우리 api 에 없는 이름»을 부르는 날.
 *      ⇒ ★ 재는 법 ⇒ 그 파일이 부르는 함수 이름을 ⇒ ⭐ 우리 `api/task-extras` 의 export 와
 *         ⇒ ⇒ 맞대어 ★ «정본에만 있는 것»이 ⭐ 1 이상인가.
 *         ⇒ ⇒ (지금은 넷이 같다 ⇒ list · create · patch · delete ChecklistTemplate)
 *   ⇒ ⚠ ⛔ 「그 파일이 생겼다」로 재지 ★ 말 것 — ⇒ ⭐ 그 파일은 ★ 지금도 «있다».
 */
import { useCallback, useEffect, useRef, useState, useSyncExternalStore } from 'react';
/*
 * ⭐ `ClipboardList` 를 ★ 더했다 — 정본은 서식 아이콘의 폴백으로 ⛔ 이모지(📋)를 썼다.
 *   ⇒ CLAUDE.md 디자인 가이드: 「색·간격·높이·반경·글자는 토큰만 — 인라인 hex 금지 · ★ 이모지 금지」
 *   ⇒ ⚠ 정직하게 적는다: ★ 이 레포도 깨끗하지 않다 — main 제품 파일 ⭐ 14개에 이모지가 있다
 *     (잰 명령: git grep -lP '[\x{1F300}-\x{1FAFF}]' origin/main -- 'apps/frontend/src/**' | grep -v .test.)
 *   ⇒ ⇒ ⭐ 그러니 이것은 «회귀를 막은 것»이 아니라 ★ «새로 더하지 않은 것»이다.
 *   ⇒ ★ 사용자가 저장한 `t.icon` 은 ⭐ 그대로 그린다 — 그것은 «내 글자»가 아니라 «데이터»다.
 */
import { Plus, X, GripVertical, Trash2, ClipboardList } from '../../icons';
import {
  listChecklistTemplates, createChecklistTemplate, patchChecklistTemplate, deleteChecklistTemplate,
  type ChecklistTemplateDto, type ChecklistTemplateScope,
} from '../../api/task-extras';
import { DetailPageHeader } from '../ProjectPage/DetailPageHeader';
// 저장 줄 한 벌(2026-10-18 · web 레인 W8b)
import { SaveBar } from '../../components/shared';
import { tProject, getProjectLang, subscribeProjectLang } from '../../lib/project-i18n';
import '../ProjectPage/ProjectPage.css';
/*
 * ⚠ `MyTasksBoard.css` 를 ★ 새 폴더로 «통째로» 가져왔다(1,363줄).
 *   ⇒ 이 판이 쓰는 클래스는 ★ 34 가지인데 그 파일의 선택자는 ⭐ 217 가지다.
 *   ⇒ ⛔ 그래도 ★ 쪼개지 «않았다» — ⭐ 정본의 «공유» CSS 이고 ★ 뒤 메뉴(my-tasks)가 나머지를 쓴다.
 *     ⇒ ⇒ 쪼개면 ★ 그 메뉴가 깨지고, ⭐ 「무엇이 어느 쪽인가」를 내가 정하는 일이 된다.
 */
import './MyTasksBoard.css';

/**
 * ChecklistTemplatesPage (AW-004-04, 2026-08-18) — 체크리스트 템플릿 관리.
 *
 * 여기서 만든 템플릿이 업무 상세(AW-004-03)의 "템플릿에서 가져오기" 목록에 그대로 나온다.
 * 템플릿의 서식은 **이름 + 순서가 있는 기본 항목 목록** 하나뿐이고, 항목은 업무로 가져갈 때
 * 전부 미체크 상태로 복사된다.
 *
 * 저장은 항목 **전체 교체**다 — 화면이 통째로 편집하는 형태라 항목별 부분 저장은 왕복만 늘린다.
 * 순서는 위/아래 버튼으로 바꾼다(드래그 대신) — 키보드로도 같은 조작이 되게 하기 위함이다.
 *
 * ──────────────────────────────────────────────────────────────────────────────
 * ## ⭐ 2026-10-08 — main 으로 옮기며 ★ 바꾼 것 (2차 2-2′ · 깃발 `PROJECT_V2` 뒤)
 *
 * ⛔ 이 파일은 깃발이 ★ «꺼진» 동안 안 돈다 — 라우터가 `ProjectV2Route` 를 거친다.
 *
 * ```
 * ① 서식 아이콘 폴백  ⛔ 이모지(📋) ⇒ ✅ ClipboardList (위 import 머리말)
 * ② 가져오는 길       ./DetailPageHeader ⇒ ../ProjectPage/DetailPageHeader (폴더가 달라졌다)
 *                     ./ProjectPage.css  ⇒ ../ProjectPage/ProjectPage.css
 * ③ 이름             ChecklistTemplatesPage ⇒ ★ ChecklistTemplatesV2Page
 *                     ⇒ ⚠ 같은 이름을 두면 ⭐ 「어느 것이 사는 것인가」가 안 보인다
 *                        (정본과 이름이 겹치는 파일이 ★ 40개라 1차에서 새 폴더를 만든 까닭이다)
 * ④ api/task-extras.ts ⇒ ★ 정본의 다섯 기능 중 ⭐ «서식»만 담았다 — 그 파일 머리말 참조
 * ```
 *
 * ## ⛔ 일부러 ★ 안 바꾼 것 — ⭐ 「공유 서식」의 수정·삭제 단추
 *
 * ```
 * 아래 [저장]·[삭제] 는 ★ 고른 서식이 ⭐ 공용(SHARED)이어도 ★ 그대로 눌린다.
 * ⇒ ⚠ 서버도 지금 ★ 그것을 막지 않는다(막는 조건이 `PRIVATE && 소유자` 하나뿐).
 * ⇒ ⇒ ⭐ 사용자가 그것을 ★ «결함»으로 판정했고 ⇒ ⛔ 백엔드가 고칠 규칙을 재고 있다(2026-10-08).
 * ⇒ ✅ 그래서 ★ 화면에서 단추를 ⛔ «지우지 않았다» — 권한이 정해지면 ⭐ 그때 맞춘다.
 *   ⇒ ★ 내가 먼저 지우면 ⇒ ⛔ 「무엇이 규칙인가」가 ⭐ 두 곳(화면·서버)에서 갈린다.
 * ⇒ ⚠ DTO 에는 `isMine` 이 ★ 있다(서버가 준다) — ⭐ 이 화면은 아직 그것을 «안 읽는다».
 *   ⇒ 권한 규칙이 오면 ★ 그 칸이 ⭐ 붙일 자리다.
 * ```
 */
export function ChecklistTemplatesV2Page() {
  useSyncExternalStore(subscribeProjectLang, getProjectLang, getProjectLang);
  const [templates, setTemplates] = useState<ChecklistTemplateDto[]>([]);
  const [tab, setTab] = useState<ChecklistTemplateScope>('SHARED');
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [name, setName] = useState('');
  const [scope, setScope] = useState<ChecklistTemplateScope>('SHARED');
  const [items, setItems] = useState<string[]>([]);
  const [draft, setDraft] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const nameRef = useRef<HTMLInputElement | null>(null);

  const load = useCallback(async (keepId?: string) => {
    try {
      const rows = await listChecklistTemplates();
      setTemplates(rows);
      const pick = rows.find((r) => r.id === keepId) ?? rows.find((r) => r.scope === tab) ?? rows[0] ?? null;
      if (pick) select(pick);
      else clearForm();
    } catch (err) {
      setError((err as Error).message);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab]);

  useEffect(() => { void load(); /* 최초 1회 */ }, []); // eslint-disable-line react-hooks/exhaustive-deps

  function select(t: ChecklistTemplateDto) {
    setSelectedId(t.id);
    setName(t.name);
    setScope(t.scope);
    setItems([...t.items]);
    setDraft('');
  }

  function clearForm() {
    setSelectedId(null);
    setName('');
    setScope(tab);
    setItems([]);
    setDraft('');
  }

  function move(i: number, dir: -1 | 1) {
    setItems((cur) => {
      const next = [...cur];
      const j = i + dir;
      if (j < 0 || j >= next.length) return cur;
      [next[i], next[j]] = [next[j]!, next[i]!];
      return next;
    });
  }

  async function save() {
    const n = name.trim();
    if (busy) return;
    // 이름이 비면 **버튼을 죽이지 않고** 눌렀을 때 이유를 말한다.
    // 항목을 다 넣고 저장이 안 눌리면, 무엇이 빠졌는지 알 길이 없었다(2026-08-19 신고).
    if (!n) {
      setError(tProject('project.tmpl.err_name'));
      nameRef.current?.focus();
      nameRef.current?.scrollIntoView({ block: 'center', behavior: 'smooth' });
      return;
    }
    // 입력줄에 쳐 놓고 Enter 를 누르지 않은 항목도 저장에 포함한다.
    // 종전에는 "재현 조건 확인" 을 치고 곧장 [저장] 을 누르면 그 줄이 조용히 사라져
    // **항목 0개짜리 템플릿**이 만들어졌다(그러면 업무 상세의 [가져오기] 가 비활성이 된다).
    const pending = draft.trim();
    const nextItems = pending ? [...items, pending] : items;
    setBusy(true);
    setError(null);
    try {
      if (selectedId) {
        const saved = await patchChecklistTemplate(selectedId, { name: n, scope, items: nextItems });
        await load(saved.id);
      } else {
        const created = await createChecklistTemplate({ name: n, scope, items: nextItems });
        await load(created.id);
      }
    } catch (err) {
      const msg = (err as any)?.response?.data?.message ?? (err as Error).message;
      setError(msg ?? tProject('project.tmpl.err_save'));
    } finally {
      setBusy(false);
    }
  }

  // 바뀐 곳 셈(2026-10-18 · web 레인 W8b) — 저장바 상태 글 · 저장 켜짐(W8c)에 쓴다. 기준은 고른 템플릿(없으면 빈 새 폼).
  //   이름 · 공개 범위 · 항목 · 아직 넣지 않은 항목 입력(save() 가 함께 싣는다) — 넷.
  //   새 폼의 공개 범위는 늘 값을 들고 있어(탭을 옮겨도 그대로) 세지 않는다.
  const savedTemplate = selectedId ? templates.find((t) => t.id === selectedId) : undefined;
  const baseItems = savedTemplate?.items ?? [];
  const changedCount = (name.trim() !== (savedTemplate?.name ?? '').trim() ? 1 : 0)
    + (savedTemplate && scope !== savedTemplate.scope ? 1 : 0)
    + (items.length !== baseItems.length || items.some((v, i) => v !== baseItems[i]) ? 1 : 0)
    + (draft.trim() ? 1 : 0);

  async function remove() {
    if (!selectedId || busy) return;
    setBusy(true);
    try {
      await deleteChecklistTemplate(selectedId);
      setSelectedId(null);
      await load();
    } catch (err) {
      const msg = (err as any)?.response?.data?.message ?? (err as Error).message;
      setError(msg ?? tProject('project.tmpl.err_delete'));
    } finally {
      setBusy(false);
    }
  }

  const shown = templates.filter((t) => t.scope === tab);

  return (
    <div className="pj-detail-page ctp-page">
      <DetailPageHeader title={tProject('project.tmpl.heading')} />
      <p className="ctp-sub">{tProject('project.tmpl.sub')}</p>

      <div className="ctp-grid">
        <aside className="ctp-side">
          <div className="ctp-tabs" role="tablist">
            {(['SHARED', 'PRIVATE'] as ChecklistTemplateScope[]).map((s) => (
              <button
                key={s}
                type="button"
                role="tab"
                aria-selected={tab === s}
                className={`ctp-tab${tab === s ? ' ctp-tab--on' : ''}`}
                onClick={() => setTab(s)}
              >
                {tProject(s === 'SHARED' ? 'project.tmpl.shared' : 'project.tmpl.private')}
              </button>
            ))}
          </div>

          <ul className="ctp-list scrollbar-thin">
            {shown.length === 0 && <li className="ctp-empty">{tProject('project.tmpl.empty')}</li>}
            {shown.map((t) => (
              <li key={t.id}>
                <button
                  type="button"
                  className={`ctp-item${selectedId === t.id ? ' ctp-item--on' : ''}`}
                  onClick={() => select(t)}
                >
                  {/* ⭐ 폴백만 아이콘으로 바꿨다 — 사용자가 저장한 t.icon 은 ★ 그대로 그린다(데이터다). */}
                  <span className="ctp-item-ico" aria-hidden>
                    {t.icon ?? <ClipboardList size={14} />}
                  </span>
                  <span className="ctp-item-body">
                    <b>{t.name}</b>
                    <small>{tProject('project.tmpl.items_n', { n: String(t.items.length) })}</small>
                  </span>
                  <span className="ctp-item-scope">
                    {tProject(t.scope === 'SHARED' ? 'project.tmpl.shared' : 'project.tmpl.private')}
                  </span>
                </button>
              </li>
            ))}
          </ul>

          <button type="button" className="ctp-new" onClick={clearForm}>
            <Plus size={13} aria-hidden />
            {tProject('project.tmpl.new')}
          </button>
        </aside>

        <section className="ctp-editor">
          <h3 className="ctp-editor-title">{tProject('project.tmpl.edit')}</h3>

          <label className="ctp-lb" htmlFor="ctp-name">{tProject('project.tmpl.name_label')}</label>
          <input
            id="ctp-name"
            ref={nameRef}
            className="ctp-input"
            aria-invalid={error != null && !name.trim()}
            value={name}
            onChange={(e) => setName(e.target.value)}
            maxLength={100}
            placeholder={tProject('project.tmpl.name_ph')}
          />

          <div className="ctp-lb ctp-lb--mt">{tProject('project.tmpl.scope_label')}</div>
          <div className="ctp-scopes" role="radiogroup" aria-label={tProject('project.tmpl.scope_label')}>
            {(['SHARED', 'PRIVATE'] as ChecklistTemplateScope[]).map((s) => (
              <button
                key={s}
                type="button"
                role="radio"
                aria-checked={scope === s}
                className={`ctp-scope${scope === s ? ' ctp-scope--on' : ''}`}
                onClick={() => setScope(s)}
              >
                {tProject(s === 'SHARED' ? 'project.tmpl.scope_shared' : 'project.tmpl.scope_private')}
              </button>
            ))}
          </div>

          <div className="ctp-lb ctp-lb--mt">{tProject('project.tmpl.items_label')}</div>
          <ul className="ctp-items">
            {items.map((c, i) => (
              <li className="ctp-itemrow" key={`${i}-${c}`}>
                <span className="ctp-grip" aria-hidden><GripVertical size={12} /></span>
                <span className="ctp-num">{i + 1}</span>
                <input
                  className="ctp-itemedit"
                  value={c}
                  maxLength={300}
                  onChange={(e) => setItems((cur) => cur.map((x, j) => (j === i ? e.target.value : x)))}
                />
                <button type="button" className="ctp-move" onClick={() => move(i, -1)} disabled={i === 0} aria-label={tProject('project.tmpl.move_up')} data-tip={tProject('project.tmpl.move_up')}>↑</button>
                <button type="button" className="ctp-move" onClick={() => move(i, 1)} disabled={i === items.length - 1} aria-label={tProject('project.tmpl.move_down')} data-tip={tProject('project.tmpl.move_down')}>↓</button>
                <button
                  type="button"
                  className="ctp-del"
                  aria-label={tProject('project.tmpl.item_delete_aria', { name: c })}
                  onClick={() => setItems((cur) => cur.filter((_, j) => j !== i))}
                >
                  <X size={12} aria-hidden />
                </button>
              </li>
            ))}
          </ul>

          <div className="ctp-additem">
            <Plus size={13} aria-hidden />
            <input
              value={draft}
              onChange={(e) => setDraft(e.target.value)}
              placeholder={tProject('project.tmpl.item_ph')}
              aria-label={tProject('project.tmpl.item_ph')}
              onKeyDown={(e) => {
                if (e.key !== 'Enter') return;
                const c = draft.trim();
                if (!c) return;
                setItems((cur) => [...cur, c]);
                setDraft('');
              }}
            />
          </div>

          {error && <div className="pj-error" role="alert">{error}</div>}

          {items.length === 0 && !draft.trim() && (
            <p className="ctp-warn" role="status">{tProject('project.tmpl.warn_empty')}</p>
          )}

          {/* 저장 줄 한 벌(2026-10-18 · web 레인 W8b) — 저장 함수 · 지우기 단추는 종전 그대로.
              W8c(시안 69 «고칠 2»): 바뀐 것이 없으면 저장이 꺼진다. 이름만 비고 다른 칸이 바뀌었으면
              켜진 채 두어, 누르면 save() 가 이유를 말하고 그 칸으로 데려간다(2026-08-19 신고 대응 그대로). */}
          <SaveBar
            className="ctp-foot"
            message={changedCount > 0
              ? tProject('project.tmpl.unsaved', { n: changedCount })
              : tProject('project.tmpl.unchanged')}
            canSave={!busy && changedCount > 0}
            onSave={() => void save()}
            saving={busy}
            saveLabel={busy ? tProject('project.btn.saving') : tProject('project.btn.save')}
            enableHint={tProject('project.tmpl.enable_hint')}
            secondary={selectedId && (
              <button type="button" className="ctp-remove" onClick={() => void remove()} disabled={busy}>
                <Trash2 size={12} aria-hidden />
                {tProject('project.tmpl.delete')}
              </button>
            )}
          />
        </section>
      </div>
    </div>
  );
}
